<template>
	<div style="min-width: 100%; max-width: 480px">
		<div
			class="bg-white w-full rounded-lg flex items-center justify-center border border-gray-600 overflow-hidden"
			style="aspect-ratio: 960/525"
		>
			<picture class="w-full h-full object-contain">
				<source
					srcset="
						https://static.birdeatsbug.com/onboarding-videos/complete-signup-ready-1x.gif 1x,
						https://static.birdeatsbug.com/onboarding-videos/complete-signup-ready-2x.gif 2x,
						https://static.birdeatsbug.com/onboarding-videos/complete-signup-ready-3x.gif 3x
					"
					type="image/gif"
				/>
				<img
					src="https://static.birdeatsbug.com/onboarding-videos/complete-signup-ready-1x.gif"
					type="image/gif"
				/>
			</picture>
		</div>
		<div class="mt-24 page-container mx-auto">
			<template v-if="$auth.isAuthenticated.value">
				<button
					class="justify-center w-auto block mx-auto px-16 mb-12 font-semibold button-yellow text-md button-large focus:ring-2 focus:ring-offset-2 ring-offset-gray-800 focus:ring-gray-500"
					@click="onConfettiButtonClick"
				>
					Pop some more confetti 🎉
				</button>
				<button
					class="block w-full text-center px-12 py-10 mx-auto font-semibold rounded text-md focus:ring-2 focus:ring-offset-2 ring-offset-gray-800 focus:ring-gray-500 link-gray"
					@click="goToWorkspace"
				>
					Go to my workspace instead
				</button>
			</template>
			<template v-else>
				<button
					class="justify-center w-auto block mx-auto mb-12 font-semibold button-green text-md button-large focus:ring-2 focus:ring-offset-2 ring-offset-gray-800 focus:ring-gray-500"
					@click="$auth.login"
				>
					Sign up and create a workspace
				</button>
				<button
					class="block text-center px-12 py-10 mx-auto font-semibold rounded text-md focus:ring-2 focus:ring-offset-2 ring-offset-gray-800 focus:ring-gray-500 link-gray"
					@click="onConfettiButtonClick"
				>
					or pop some more confetti 🎉
				</button>
			</template>
		</div>
	</div>
</template>

<script>
/* eslint-disable no-console */
import analytics from 'shared/utils/analytics'
import messageExtension from 'shared/utils/messageExtension'
import {useUserCategory} from 'shared/composables/useUserCategory'

const confettiOptions = {
	particleCount: 100,
	spread: 70,
	origin: {y: 0.6},
	disableForReducedMotion: true,
}

export default {
	name: 'CompleteSignupReady',
	setup() {
		const {userCategory} = useUserCategory()
		return {userCategory}
	},
	computed: {
		userDataLoaded() {
			return Boolean(this.$store.user?.id && this.$store.workspace?.id)
		},
	},
	watch: {
		'$store.user.id': {
			immediate: true,
			handler: function (userId) {
				if (!userId) return
				messageExtension('setUserInformation', {userInformation: {user: this.$store.user}})
			},
		},
		userDataLoaded: {
			handler(userDataLoaded) {
				if (!userDataLoaded) return
				analytics.page('BEBInstallationSuccessPageVisited', {user_category: this.userCategory})
				//This is implemented so this event can be tracked as an event and get populated in appcues event drop down refer: https://docs.appcues.com/dev-installing-appcues/installation-overview-for-developers?from_search=162506555
				analytics.track('BEBInstallationSuccessPageVisited', {
					user_category: this.userCategory,
				})
			},
			immediate: true,
		},
	},
	mounted() {
		analytics.page('BEBInstallationSuccessPageVisited')
		//This is implemented so this event can be tracked as an event and get populated in appcues event drop down refer: https://docs.appcues.com/dev-installing-appcues/installation-overview-for-developers?from_search=162506555
		analytics.track('BEBInstallationSuccessPageVisited')
		const script = document.createElement('script')

		script.onload = () => {
			window.confetti(confettiOptions)
		}

		script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.7.0/dist/confetti.browser.min.js'
		document.head.appendChild(script)
	},
	methods: {
		onConfettiButtonClick() {
			analytics.track('InteractedWithBEBInstallationSuccessPage', {
				action: 'ClickedOnPopConfetti',
			})
			if (window?.confetti) window.confetti(confettiOptions)
			this.generateConsoleLogs()
		},
		goToWorkspace() {
			analytics.track('InteractedWithBEBInstallationSuccessPage', {
				action: 'ClickedOnGoToMyWorkspace',
			})
			window.dispatchEvent(new CustomEvent('complete-signup-next-step', {detail: {stepId: 'final'}}))
		},
		generateConsoleLogs() {
			setTimeout(() => {
				console.log('======================= Bug Capture ========================')
				console.log('The logs below were auto-generated for demonstration purposes.')
				console.log('==============================================================')
			}, 100)

			setTimeout(() => {
				console.error('this is a console.error')
			}, 100)

			setTimeout(() => {
				console.log(1, 'string', true, false, [1, 2, 3, [4, 5, 6]])
			}, 200)

			setTimeout(() => {
				localStorage.myKey = JSON.stringify({objKey1: 'objValue1', objKey2: 2})
				sessionStorage.setItem('myKey', 'myValue')
			}, 250)

			setTimeout(() => {
				console.assert(false, 'this is a failed assertion', {
					element: document.getElementsByTagName('button')[0],
					message: 'button content is "CLICK ME"',
				})
			}, 300)

			setTimeout(() => {
				class Peca {
					constructor(a) {
						this.a = a
					}
				}
				const obj = {
					number: 2,
					inf: Infinity,
					infMinus: -Infinity,
					infPlus: +Infinity,
					zeroPlus: +0,
					zeroMinus: -0,
					string: 'hello',
					array: [1, 2, 3],
					object: {
						number: 1,
						object: {
							number: 3,
						},
					},
					error: new Error('hello'),
					aBoolean: true,
					aDate: new Date(1565282142495),
					aRegExp: /aaa/i,
					peca: new Peca(1),
					function: function hello() {
						return 1
					},
					arrowFunction: () => 1,
					map: new Map([['hello', 'world']]),
					set: new Set([123, 456]),
					Int8Array: new Int8Array([1, 2, 3]),
					Uint8Array: new Uint8Array([1, 2, 3]),
					Uint8ClampedArray: new Uint8ClampedArray([1, 2, 3]),
					Int16Array: new Int16Array([1, 2, 3]),
					Uint16Array: new Uint16Array([1, 2, 3]),
					Int32Array: new Int32Array([1, 2, 3]),
					Uint32Array: new Uint32Array([1, 2, 3]),
					Float32Array: new Float32Array([1, 2, 3]),
					Float64Array: new Float64Array([1, 2, 3]),
				}
				console.dir(obj)
			}, 400)

			setTimeout(() => {
				throw new Error('this is an error')
			}, 500)

			setTimeout(() => {
				console.dirxml(document.getElementsByTagName('button')[1])
			}, 600)

			setTimeout(() => {
				throw new TypeError('this is a type error')
			}, 700)

			setTimeout(() => {
				throw new Error('this is an error inside a promise')
			}, 800)

			setTimeout(() => {
				fetch('/img/bird-404.svg')
			}, 900)

			setTimeout(() => {
				fetch('https://dog.ceo/api/breeds/image/random')
			}, 1000)

			setTimeout(() => {
				fetch('https://api.birdeatsbug.com')
			}, 1100)

			setTimeout(() => {
				console.trace('trace me!')
				console.trace()
			}, 1200)

			setTimeout(() => {
				console.time('myTimer')
				console.count('myCounter')
				console.group('group1')
				console.groupCollapsed('group2')
				console.table(['tableRow1', 'tableRow2', 'tableRow3'])
				console.groupEnd('group2')
				console.groupEnd('group1')
			}, 1400)

			setTimeout(() => {
				console.count('myCounter')
				console.count('myCounter')
				console.countReset('myCounter')
				console.count('myCounter')
				console.timeLog('myTimer')
			}, 1500)

			setTimeout(() => {
				console.profile()
				console.timeStamp('myTimer')
				setTimeout(() => console.profileEnd(), 200)
				console.timeEnd('myTimer')
			}, 1600)

			setTimeout(() => {
				localStorage.removeItem('myKey')
				sessionStorage.removeItem('myKey')
			}, 1700)
		},
	},
}
</script>
